// extracted by mini-css-extract-plugin
export default {"root":"ProfileMenu_root__fIedK","list":"ProfileMenu_list__VEB+2","list__item":"ProfileMenu_list__item__ZcdGw","link":"ProfileMenu_link__M1efx","active":"ProfileMenu_active__pEXjp"};